import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'

const getStyles = (theme: Theme) => ({
  noResults: {
    width: '100%',
    textAlign: 'center',
    padding: theme.spacing(0),
    color: theme.palette.text.disabled,
    fontSize: '14px',
  },

  zero: {
    fontSize: '24px',
    fontWeight: 600,
  },
})

interface Props {
  label: string
}

export const ServiceNoResultsCard: React.FC<Props> = (props) => {
  const styles = getStyles(useTheme())
  return (
    <Card sx={styles.noResults} square elevation={1}>
      <Box sx={styles.zero}>0</Box>
      {props.label}
    </Card>
  )
}
ServiceNoResultsCard.displayName = 'ServiceNoResultsCard'
